package com.tixforgigs.common.ui.components.forms

import com.tixforgigs.common.core.annotations.MissingTaramiIconKey
import com.tixforgigs.common.core.util.IdHelper.generateRandomId
import com.tixforgigs.common.ui.components.icons.Icon
import com.tixforgigs.common.ui.components.mandarin.mandarinFilledIconButton
import io.kvision.core.AlignItems
import io.kvision.core.Container
import io.kvision.core.JustifyContent
import io.kvision.event.clickFlow
import io.kvision.event.inputFlow
import io.kvision.material.ExperimentalMaterialApi
import io.kvision.material.divider.divider
import io.kvision.material.icon.leadingIcon
import io.kvision.material.icon.trailingIcon
import io.kvision.material.list.listItem
import io.kvision.material.menu.MenuItemType
import io.kvision.material.menu.MenuPositioning
import io.kvision.material.menu.menu
import io.kvision.material.menu.menuItem
import io.kvision.material.slot.supportingText
import io.kvision.material.textfield.TextFieldInputType
import io.kvision.material.textfield.outlinedTextField
import io.kvision.material.widget.FocusState
import io.kvision.panel.hPanel
import io.kvision.panel.vPanel
import io.kvision.state.bind
import io.kvision.utils.perc
import io.kvision.utils.px
import kotlinx.coroutines.MainScope
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.launchIn
import kotlinx.coroutines.flow.onEach
import kotlinx.coroutines.flow.update

@OptIn(ExperimentalMaterialApi::class)
fun <T> Container.templateSearchField(
  inputLabel: String,
  initialSelectedItems: List<T>? = null,
  itemLabel: (T) -> String = { it.toString() },
  inputLeadingIcon: String? = null,
  inputTrailingIcon: String? = null,
  inputRequired: Boolean = false,
  onUpdateSelectedItems: (List<T>) -> Unit = {},
  onInput: (suspend (String) -> List<T>)? = null,
) {
  val menuId = generateRandomId(numbersAllowed = false)

  val searchItems = MutableStateFlow<List<T>>(emptyList())
  val selectedItems = MutableStateFlow<List<T>>(initialSelectedItems.orEmpty())

  vPanel(spacing = 16) {
    margin = 16.px

    val menu = menu(
      anchor = menuId,
      positioning = MenuPositioning.Popover,
      defaultFocus = FocusState.None
    ).bind(searchItems) { items ->
      items.forEach { item ->
        menuItem(
          type = MenuItemType.Option,
        ) {
          supportingText(itemLabel(item))
        }.clickFlow.onEach {
          selectedItems.update { it + item }
        }.launchIn(MainScope())
      }
    }
    outlinedTextField(
      label = inputLabel,
      type = TextFieldInputType.Search,
      required = inputRequired,
    ) {
      id = menuId
      inputLeadingIcon?.let {
        leadingIcon(it)
      }
      inputTrailingIcon?.let {
        trailingIcon(it)
      }
    }.inputFlow.onEach { input ->
      if (menu.open.not() && searchItems.value.isNotEmpty()) {
        menu.open()
      }
      onInput?.let { onInput ->
        searchItems.update { onInput(input.value) }
      }
    }.launchIn(MainScope())

    vPanel().bind(selectedItems) { items ->
      onUpdateSelectedItems(items)
      items.forEachIndexed { index, item ->
        hPanel(
          justify = JustifyContent.START,
          alignItems = AlignItems.CENTER
        ) {
          listItem(
            text = itemLabel(item)
          ) {
            width = 100.perc
            @MissingTaramiIconKey
            trailingIcon("check_small")
          }
          @MissingTaramiIconKey
          mandarinFilledIconButton(
            iconName = Icon.DELETE
          ) {
            selectedItems.update { it - item }
          }
        }
        if (index < items.lastIndex) {
          divider()
        }
      }
    }
  }
}
